import React, { StrictMode } from "react";

import { LoggedInHTTPError } from "@impero-com/common/errorPages/loggedInHTTPError";
import { useTranslation } from "@impero-com/common/utils/i18n";
import type { NavRowId } from "@impero-com/ui/domain";

import { OrganizationFeatureFlag } from "api/generated/model";
import { ErrorBoundary } from "components/errorBoundary";
import { useFeatureFlag } from "utils/hooks/useFeatureFlag";

import { Body } from "../org/body";

interface FeatureGateProps {
    featureFlag: OrganizationFeatureFlag;
    title: string;
    navId: NavRowId;
    routeKey: string;
    children: React.ReactNode;
}
export function FeatureGate({
    featureFlag,
    title,
    navId,
    routeKey,
    children,
}: FeatureGateProps) {
    const enabled = useFeatureFlag(featureFlag);
    const { t } = useTranslation();
    if (!enabled) {
        return (
            <Body title={t("ErrorPage_NotFound")} navId={null} routerLinks>
                <LoggedInHTTPError code={404} />
            </Body>
        );
    }
    return (
        <StrictMode>
            <Body title={title} navId={navId} routerLinks>
                <ErrorBoundary routeKey={routeKey}>{children}</ErrorBoundary>
            </Body>
        </StrictMode>
    );
}
